import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { LanguageToggle } from './LanguageToggle';
import { useLanguage } from '../hooks/useLanguage';
import { business, navLinks } from '../data/business';
import { ui } from '../data/translations';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    t
  } = useLanguage();
  return <header className="sticky top-0 z-40 w-full border-b border-white/10 bg-navy" data-id="element-131" data-mp="2wl8nvful1ani">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-3 px-4 sm:px-5 lg:px-8" data-id="element-132" data-mp="2wivwkc2xpnxs">
        <a href="#home" aria-label={`${business.name} ${t(ui.common.home)}`} data-id="element-133" data-mp="36b1zgguq5prr">
          <Logo nameClassName="hidden sm:flex" data-id="element-134" data-mp="36d4n4u8en6tb" />
        </a>

        <nav aria-label="Main" className="hidden items-center gap-7 lg:flex" data-id="element-135" data-mp="3bb64naq6my2o">
          {navLinks.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-sm font-medium text-white/80 transition-colors duration-150 hover:text-gold" data-id="element-136" data-mp="3fc9kvyc56w4f">
              {t(link.label)}
            </a>)}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3" data-id="element-137" data-mp="2mng7wzwkj4gm">
          <LanguageToggle data-id="element-138" data-mp="2hntuapctvm7a" />
          <a href={business.phoneHref} className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-gold px-4 py-2.5 text-sm font-semibold text-navy-deep transition-colors duration-150 hover:bg-gold-dark xl:inline-flex" data-id="element-139" data-mp="2hon5c2itkxv8">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="35lj2du7vxtlt" />
            {business.phoneDisplay}
          </a>
          <a href={business.phoneHref} aria-label={`${t(ui.cta.callNow)} ${business.phoneDisplay}`} className="flex h-12 w-12 items-center justify-center rounded-md bg-gold text-navy-deep xl:hidden" data-id="element-141" data-mp="30mzfnrlgwdse">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-142" data-mp="3t9k3ii2qi7r7" />
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? t(ui.common.menuClose) : t(ui.common.menuOpen)} className="flex h-12 w-12 items-center justify-center rounded-md border border-white/20 text-white lg:hidden" data-id="element-143" data-mp="1remf6mnzy6hr">
            {open ? <XIcon className="h-5 w-5" data-id="element-144" data-mp="18mtvxjyqbzn8" /> : <MenuIcon className="h-5 w-5" data-id="element-145" data-mp="18lij6unb3hjz" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-146" data-mp="1cpgfkxl8ye9c">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-white/10 bg-navy lg:hidden" data-id="element-147" data-mp="yovxy4r2iohf">
            <ul className="flex flex-col px-5 py-3" data-id="element-148" data-mp="2y1hw8mu1pr4w">
              {navLinks.map(link => <li key={link.href} data-id="element-149" data-mp="mffz69g87192">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-3.5 text-base font-medium text-white" data-id="element-150" data-mp="mcboct89979f">
                    {t(link.label)}
                  </a>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}